import { FC, ReactNode } from 'react';
import { createUseStyles } from 'react-jss';
import { IonButton } from '@ionic/react';
import { CloseIcon, IconComponent } from '../theme/Icons';

const useStyles = createUseStyles({
    banner: {
        marginTop: 14,
        background: 'rgba(var(--ion-color-primary-rgb), 0.10)',
        borderRadius: 10,
        padding: 14
    },
    topRow: {
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: 8
    },
    head: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        color: 'var(--ion-color-primary)',
        fontSize: 16,
        fontWeight: 600
    },
    close: {
        alignSelf: 'flex-start',
        margin: '-6px -6px 0 0',
        '--padding-start': '2px',
        '--padding-end': '2px',
        height: 28
    },
    message: {
        fontSize: 14,
        color: 'var(--ion-color-step-750)',
        marginTop: 6,
        lineHeight: 1.5
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        marginTop: 12,
        // a block button fills the row, as it would outside a flex container
        '& > ion-button[expand="block"]': {
            flex: 1
        }
    }
});

// A tinted card: icon and title (`${data-type}-title`), a message (`${data-type}-message`), then its
// actions. With onDismiss it has a close button, `${data-type}-dismiss`.
export const InfoBanner: FC<{
    'data-type': string;
    Icon: IconComponent;
    title: ReactNode;
    maskTitle?: boolean;
    message: ReactNode;
    onDismiss?: () => void;
    children?: ReactNode;
}> = ({ 'data-type': dataType, Icon, title, maskTitle, message, onDismiss, children }) => {
    const classes = useStyles();

    return (
        <div className={classes.banner} data-type={dataType}>
            <div className={classes.topRow}>
                <div className={`${classes.head} ${maskTitle ? 'mp-mask' : ''}`} data-type={`${dataType}-title`}>
                    <Icon color="primary" />
                    {title}
                </div>
                {onDismiss && (
                    <IonButton className={classes.close} fill="clear" color="medium" shape="round" size="small" aria-label="Dismiss" data-type={`${dataType}-dismiss`} onClick={onDismiss}>
                        <CloseIcon color="medium" />
                    </IonButton>
                )}
            </div>
            <div className={classes.message} data-type={`${dataType}-message`}>{message}</div>
            {children && <div className={classes.actions}>{children}</div>}
        </div>
    );
};
